import type { ColumnDef } from '@tanstack/react-table';
import { PersonNameCell } from './PersonNameCell';

const DISTRIBUTOR_NAME_HEADER = 'Distributor Name';

interface RowWithDistributorName {
  name: string;
  userMobile: string | null;
  designationName: string | null;
}

export function getDistributorNameColumn<TRow extends RowWithDistributorName>(
  searchText: string | undefined,
  getNote?: (row: TRow) => string | undefined,
): ColumnDef<TRow, unknown> {
  return {
    id: 'name',
    header: DISTRIBUTOR_NAME_HEADER,
    cell: ({ row }) => (
      <PersonNameCell
        name={row.original.name}
        designationName={row.original.designationName}
        mobile={row.original.userMobile}
        note={getNote?.(row.original)}
        searchText={searchText}
      />
    ),
  };
}
